import { DeepMap, FieldError } from 'react-hook-form'
import { BuscarTitulosForm } from '../../../../types/titulosTypes'
import { formatarData, formateDate, formateHoras } from '../../../../utils/stringUtils'
import { CabecalhoListaParceirosProps } from './CabecalhoListaParceiros.View'
import { cabecalhoListaParceirosStyles } from './CabecalhoListaParceiros.style'
import { customTheme } from '../../../../styles/customTheme'

export function cabecalhoListaParceirosIO({ titulosAbertos, dataUltimaAtualizacaoAbertos }: CabecalhoListaParceirosProps) {
  const verificarErros = (handleErros?: DeepMap<BuscarTitulosForm, FieldError>, erro?: FieldError) => {
    return handleErros != undefined && erro != undefined
  }
  const corDataAtualizacao = titulosAbertos && dataUltimaAtualizacaoAbertos ? customTheme.colors.cinza07 : customTheme.colors.amarelo07
  const dataUltimaAtualizacao =
    titulosAbertos && dataUltimaAtualizacaoAbertos
      ? `Última atualização: ${formateDate(dataUltimaAtualizacaoAbertos)} às ${formateHoras(dataUltimaAtualizacaoAbertos)}`
      : 'Atualizando...'

  return {
    styles: cabecalhoListaParceirosStyles,
    verificarErros,
    dataAtualPadrao: String(formatarData(new Date().toISOString(), '-')),
    dataUltimaAtualizacao,
    corDataAtualizacao
  }
}

export type CabecalhoListaParceirosIO = ReturnType<typeof cabecalhoListaParceirosIO>
